import React from 'react';
import { ReactComponent as AllTokensIcon } from 'assets/img/ic_all_tokens.svg';
import SwapSelectHeader from './SwapSelectHeader';

const SwapAllTokensHeader = () => {
  return <SwapSelectHeader text='All tokens' icon={<AllTokensIcon />} />;
};

export default SwapAllTokensHeader;
